module.exports = __webpack_public_path__ + "static/media/camera-movie.db23c672.svg";